import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, LinkedinIcon, MailIcon, SparklesIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center px-6 py-20 overflow-hidden bg-gradient-to-br from-indigo-950 via-purple-900 to-indigo-900" data-id="element-79">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-80">
        <motion.div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-br from-pink-500/30 to-orange-500/30 rounded-full blur-3xl" animate={{
        scale: [1, 1.2, 1],
        x: [0, 50, 0],
        y: [0, 30, 0]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-81" />
        <motion.div className="absolute bottom-20 right-10 w-96 h-96 bg-gradient-to-br from-purple-500/30 to-blue-500/30 rounded-full blur-3xl" animate={{
        scale: [1, 1.3, 1],
        x: [0, -30, 0],
        y: [0, -50, 0]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-82" />
        <motion.div className="absolute top-1/2 left-1/2 w-64 h-64 bg-gradient-to-br from-amber-500/20 to-pink-500/20 rounded-full blur-3xl" animate={{
        scale: [1, 1.1, 1],
        rotate: [0, 180, 360]
      }} transition={{
        duration: 15,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-83" />
      </div>

      <div className="max-w-5xl w-full relative z-10" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center" data-id="element-85">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-amber-300 text-sm font-medium mb-6" data-id="element-86">
            <SparklesIcon size={16} data-id="element-87" />
            <span data-id="element-88">Available for new opportunities</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="text-6xl md:text-8xl font-black text-white mb-6 tracking-tight" data-id="element-89">
            Chamanvir Kaur
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5,
          duration: 0.8
        }} className="text-3xl md:text-4xl font-bold mb-8" data-id="element-90">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-amber-400 via-pink-400 to-purple-400" data-id="element-91">
              Software Engineer & Problem Solver
            </span>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.7,
          duration: 0.8
        }} className="text-xl text-purple-200 max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-92">
            Crafting elegant solutions to complex problems. Passionate about
            building intuitive experiences and scalable systems that make a
            difference.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.9,
          duration: 0.8
        }} className="flex flex-wrap gap-4 justify-center mb-16" data-id="element-93">
            <a href="https://www.linkedin.com/in/chamanvir-kaur/" target="_blank" rel="noopener noreferrer" className="group flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-pink-500 to-orange-500 text-white rounded-full font-semibold hover:shadow-2xl hover:shadow-pink-500/50 transition-all duration-300 hover:scale-105" data-id="element-94">
              <LinkedinIcon size={20} data-id="element-95" />
              LinkedIn
            </a>
            <a href="mailto:your.email@example.com" className="group flex items-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white rounded-full font-semibold hover:bg-white/20 transition-all duration-300 hover:scale-105" data-id="element-96">
              <MailIcon size={20} data-id="element-97" />
              Email
            </a>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.2,
        duration: 0.8
      }} className="flex justify-center" data-id="element-98">
          <a href="#about" className="flex flex-col items-center gap-2 text-purple-300 hover:text-white transition-colors group" data-id="element-99">
            <span className="text-sm font-medium" data-id="element-100">Explore my work</span>
            <motion.div animate={{
            y: [0, 10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 2,
            ease: 'easeInOut'
          }} className="group-hover:text-amber-400 transition-colors" data-id="element-101">
              <ArrowDownIcon size={24} data-id="element-102" />
            </motion.div>
          </a>
        </motion.div>
      </div>
    </section>;
}